import React from 'react';

const BotAvatar = () => {
  return <div></div>;
};

export default BotAvatar;
